// Utility helpers for recovering from corrupted Supabase auth storage
// (e.g. broken refresh token causing the app to get stuck on a single device).

export const clearSupabaseAuthStorage = () => {
  try {
    const keysToRemove: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;

      const isSupabaseKey = key.startsWith('sb-') || key.startsWith('supabase.');
      if (!isSupabaseKey) continue;

      const isAuthRelated = /auth|token|code-verifier|pkce|oauth/i.test(key);
      if (isAuthRelated) keysToRemove.push(key);
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore
  }
};
